import * as e from "react";
import { forwardRef as l } from "react";
const a = l(
  function(t, r) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: r,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M10.5 15.5L11 19L10 22.5M10.5 15.5L9 19M10.5 15.5V12.185C10.5 12.0656 10.5427 11.9502 10.6204 11.8596L13.5 8.5V5",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 2.04
        }
      ),
      /* @__PURE__ */ e.createElement(
        "circle",
        {
          cx: 10.0357,
          cy: 8.03571,
          fill: "#000",
          r: 2.23571,
          stroke: "#ECECEC",
          strokeWidth: 0.4
        }
      ),
      /* @__PURE__ */ e.createElement("circle", { cx: 17.0357, cy: 2.03571, fill: "#000", r: 2.03571 })
    );
  }
);
export {
  a as BetBuilderBadgeBasketballThrees
};
